import { LocationNumbersService } from "../../../services";

const fetchShowUKKYCBanner = async function ({ commit, dispatch, state }, config) {
    const { locationId } = config

    try {
        const data = await LocationNumbersService.fetchShowUKKYCBanner(locationId);
        return data;
    } catch (error) {
        throw error;
    }
};

export default fetchShowUKKYCBanner;